<template>
    <div>
        <div id="teaSetting-container">
            <el-form ref="initForm" label-width="120px" label-position="left">
                <el-form-item label="当前教师">
                    {{ oriTeaName }}
                </el-form-item>
                <el-form-item label="更改教师" prop="teaCodeArray">
                    <el-select v-model="teaCodeArray" placeholder="请选择" style="width:100%;"
                        @visible-change="handleVisibleChange" @change="handleTeaChange" multiple filterable clearable>
                        <el-option v-for="(item, index) in comboOption.tea"
                            :key="item.comboValue"
                            :value="item.comboValue"
                            :label="item.comboName + item.otherInfo"
                            :disabled="item.comboState">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer" style="float:right; margin-top:10px">
            <el-button type="primary" @click="confirm">确定</el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            return {
                queryForm: {
                    semesterCode: null,
                    classCode: null,
                    timeOrder: null,
                    teaCode: null,
                    week: null,
                },
                comboOption: {
                    tea: null
                },
                oriTeaCode: null,
                oriTeaName: null,
                newTeaCode: null,
                newTeaName: null,
                teaCodeArray: [],
                containerHeight: null,
            }
        },
        mounted() {
            this.containerHeight = document.getElementById('teaSetting-container').offsetHeight;
            this.$emit('updateTeaDialogHeight', this.containerHeight + 65);
        },
        methods: {
            queTeaCombo(){
                this.$api.timetableManage.arrange.queTeaCombo4Change({
                    data: this.queryForm
                }).then((response) => {
                    this.comboOption.tea = response.data.data;
                    this.handleComboValue();
                }).catch(error => {
                    console.log(error);
                });
            },
            handleComboValue(){
                //判断当前选中的场地编号是否在下拉框中
                outer: for(let i=0; i<this.teaCodeArray.length; i++){
                    for(let j=0; j<this.comboOption.tea.length; j++){
                        if(this.teaCodeArray[i]===this.comboOption.tea[j].comboValue && this.comboOption.tea[j].comboState===false){
                            continue outer;
                        }
                    }

                    this.teaCodeArray.splice(i, 1);
                    i--;
                }

                this.handleTeaChange();
            },
            handleTeaChange(){
                setTimeout(() => {
                    if(this.containerHeight != document.getElementById('teaSetting-container').offsetHeight){
                        this.containerHeight = document.getElementById('teaSetting-container').offsetHeight;
                        this.$emit('updateTeaDialogHeight', this.containerHeight + 65);
                    }
                }, 100);
            },
            handleVisibleChange(isVisible){
                if(isVisible){
                    this.queTeaCombo();
                }
            },
            confirm() {
                if(this.teaCodeArray.length === 0){
                    this.$message({
                        message: '请选择授课教师',
                        type: 'error'
                    });
                    return;
                }

                let finalTeaInfo = {
                    teaCode: '',
                    teaName: '',
                };
                for(let i=0; i<this.teaCodeArray.length; i++){
                    for(let j=0; j<this.comboOption.tea.length; j++){
                        if(this.teaCodeArray[i] === this.comboOption.tea[j].comboValue){
                            finalTeaInfo.teaCode += this.comboOption.tea[j].comboValue + '+';
                            finalTeaInfo.teaName += this.comboOption.tea[j].comboName + '+';
                        }
                    }
                }
                finalTeaInfo.teaCode = finalTeaInfo.teaCode.substring(0, finalTeaInfo.teaCode.length-1);
                finalTeaInfo.teaName = finalTeaInfo.teaName.substring(0, finalTeaInfo.teaName.length-1);

                this.$emit('updateTeaInfo', finalTeaInfo);
            },
            //关闭对话框
            closeDialog() {
                this.$emit('closeTeaSettingDialog');
            },
        },
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// teaSetting.vue?017eb209